export default {
    searchTerm: '',
    selectedSite: '',
    applicationMode: 'simple',
    apiValoAuth: window.config.use_apivalo_auth,

    casings: {
        aluminium: 'Aluminium',
        cast_iron: 'Fonte',
        atex: 'ATEX',
    },
    applications: {
        centrifugal_ventilation: 'Ventilation centrifuge',
        axial_ventilation: 'Ventilation axiale',
        pumping: 'Pompage',
        motor: 'Moteur',
    },
    regulations: {
        centrifugal_ventilation: {
            drawing_beforehand_with_registers: 'Laminage amont par registres',
            drawing_afterwards_with_registers: 'Laminage aval par registres',
            drawing_beforehand_with_valves: 'Laminage amont par vantelles',
            electronic_speed_variation: 'Variation électronique de vitesse',
            no_adjustment: 'Pas de réglage',
        },
        axial_ventilation: {
            blades_with_self_adjusting_interval: 'Pâles à pas auto-réglables',
            drawing_afterwards: 'Laminage aval',
            electronic_speed_variation: 'Variation électronique de vitesse',
            no_adjustment: 'Pas de réglage',
        },
        motor: {
            no_adjustment: 'Pas de réglage',
        },
        pumping: {
            by_pass: 'By-pass',
            throttle_valve: 'Vanne de laminage',
            coupler: 'Coupleur',
            all_or_none: 'T.O.R.',
            electronic_speed_variation: 'Variation électronique de vitesse',
            no_adjustment: 'Pas de réglage',
        }
    },
};



// WEBPACK FOOTER //
// ./src/store/state.js